import { useState } from 'react';
export const useServerValidation = () => {
    const [errors, setErrorsState] = useState({});
    const setErrors = (errorsArray) => {
        const newErrors = {};
        errorsArray.forEach((error) => {
            if (error.path && error.msg) {
                newErrors[error.path] = error.msg;
            }
        });
        setErrorsState(newErrors);
    };
    const clearError = (field) => {
        setErrorsState((prevErrors) => {
            const newErrors = Object.assign({}, prevErrors);
            delete newErrors[field];
            return newErrors;
        });
    };
    const clearAllErrors = () => {
        setErrorsState({});
    };
    return {
        errors,
        setErrors,
        clearError,
        clearAllErrors,
    };
};
